import { Category } from './wikis';
import { makeRequest, CommonRequestOptions } from './makeRequest';

type GetCategoriesRequestOptions = CommonRequestOptions & {
   modifiedSince?: number;
   offset?: number;
   limit?: number;
   langid?: string;
};

export async function getCategories({
   modifiedSince,
   offset,
   limit,
   langid,
   ...common
}: GetCategoriesRequestOptions): Promise<Category[]> {
   return await makeRequest('get', 'wikis/CATEGORY', {
      ...common,
      query: {
         modifiedSince,
         offset,
         limit,
         langid,
      },
   });
}
